import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from '@/contexts/auth/AuthContext';
import { DepartmentList } from './DepartmentList';
import { RoleManagement } from '@/components/organizations/RoleManagement';

const DepartmentsPage: React.FC = () => {
  const { currentOrganization } = useAuth();
  const [activeTab, setActiveTab] = useState("departments");

  if (!currentOrganization) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-2">No Organization Selected</h2>
          <p className="text-muted-foreground">Please select or create an organization to manage departments</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 p-6 pb-16 animate-fade-in">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Department Management</h1>
        <p className="text-muted-foreground">
          Manage departments and team members in your organization
        </p>
      </div>
      
      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="departments">Departments</TabsTrigger>
          <TabsTrigger value="team-roles">Team & Roles</TabsTrigger>
        </TabsList>
        
        <TabsContent value="departments" className="space-y-4">
          <DepartmentList />
        </TabsContent>
        
        <TabsContent value="team-roles" className="space-y-4">
          <RoleManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default DepartmentsPage;
